<template>
  <div class="clock-timer-container" :style="{ backgroundColor: background }">
    <div v-if="isOver" class="click-timer-over">
      <span>活动已结束</span>
    </div>
    <div v-else class="clock-timer">
      <span>距活动结束仅剩</span>
      <span class="t" :style="{ backgroundColor: backgroundClock }">
        {{ limitTime[0] }}
      </span>
      <span>天</span>
      <span class="t" :style="{ backgroundColor: backgroundClock }">
        {{ limitTime[1] }}
      </span>
      <span class="c">:</span>
      <span class="t" :style="{ backgroundColor: backgroundClock }">
        {{ limitTime[2] }}
      </span>
      <span class="c">:</span>
      <span class="t" :style="{ backgroundColor: backgroundClock }">
        {{ limitTime[3] }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  // props: ['time', 'background', 'backgroundClock'],
  props: {
    time: {
      type: Date,
      default: undefined,
    },
    background: {
      type: String,
      default: '',
    },
    backgroundClock: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      timeId: null,
      limitTime: [],
      isOver: false,
    }
  },
  created() {
    this.countdown(this.time)
  },
  methods: {
    countdown(end) {
      let timeId = null
      // 相差的毫秒数
      const msec = Date.newDate(end).getTime() - new Date().getTime()
      if (msec <= 0) {
        this.isOver = true
        console.log('is over')
        this.$emit('on-timeend')
        return clearTimeout(timeId)
      }
      const remainTime = Date.formatMs(msec, 'DD hh mm ss')
      this.limitTime = remainTime.split(' ')
      // 一秒后递归
      timeId = setTimeout(() => {
        this.countdown(end)
      }, 1000)
    },
  },
}
</script>
<style lang="less" scoped>
@import (reference) url(../variable.less);
.clock-timer-container {
  height: 70px;
  background-color: #660d0d;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .clock-timer,
  .click-timer-over {
    span {
      font-family: PingFangSC-Medium;
      font-size: 24px;
      color: #ffffff;
      &.t {
        font-family: Arial-BoldMT;
        background-color: #e94b42;
        border-radius: 8px;
        padding: 4px 9px;
        margin: 0 4px;
      }
      &.c {
        margin: 0;
      }
    }
  }
}
</style>
